import request from '@/utils/httpRequest'

export default class EquipmentMaintenance {
  queryEquipmentMaintenanceById(id) {
    return request({
      url: '/equipment/wuyeEquipmentMaintenance/queryById',
      method: 'get',
      params: { id: id }
    })
  }

  startFlow(params) {
    return request({
      url: '/equipment/wuyeEquipmentMaintenance/startFlow',
      method: 'post',
      data: params
    })
  }
}
